/**
 * Custom anchor links logic
 *
 * USAGE:
 * <a href="#target" class="custom-anchor" data-scroll-behavior="instant" data-scroll-offset="10" data-scroll-offset-element=".sticky-header">Anchor link</a>
 *
 * data-scroll-behavior:       Sets scroll behavior. Default is 'smooth'.
 * data-scroll-offset:         Sets specific offset value.
 * data-scroll-offset-element: Set offset value by another element. Numeric offset value and element offset value will be combined.
 */
class AnchorLinks {
  /**
   * @constructor
   * @param {HTMLElement} element element to bind to
   */
  constructor(element) {
    this._element = element;

    this._element.addEventListener('click', this._onClick.bind(this));
  }

  /**
   * Called when a anchor links is clicked
   * @param {Event} event mouse click event
   */
  _onClick(event) {
    event.preventDefault();

    const targetElement = document.querySelector(event.target.hash);

    if (targetElement) {
      AnchorLinks.offsetScroll(this._element, targetElement);

      // Add hash to url
      history.pushState(null, null, event.target.hash);
    }
  }

  /**
   * Scroll to element with offset
   * @param {HTMLElement} element element that was clicked
   * @param {HTMLElement} target element to scroll to
   */
  static offsetScroll(element, target) {
    const scrollBehaviorList = {
      auto: 'auto',
      instant: 'instant',
      smooth: 'smooth'
    };

    // Set scroll behavior. Default is 'smooth'.
    const scrollBehavior = scrollBehaviorList[element.dataset?.scrollBehavior] ?? scrollBehaviorList.smooth;

    // Get offset element for offset value
    const offsetElementSelector = element.dataset.scrollOffsetElement;
    const offsetElement = typeof offsetElementSelector === 'string' ? document.querySelector(offsetElementSelector) : 0;
    const offsetElementHeight = offsetElement?.offsetHeight ?? 0;

    const scrollOffset = (parseInt(element.dataset.scrollOffset) || 0) + offsetElementHeight;
    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: elementPosition - scrollOffset,
      behavior: scrollBehavior
    });
  }

  static init() {
    document.querySelectorAll('a[href^="#"].custom-anchor').forEach(linkElement => {
      new AnchorLinks(linkElement);
    });
  }
}

export default AnchorLinks;
